import { HotDealsProps } from './types';
import DefaultBanner from './Themes/DefaultBanner';
import CyberWeekBanner from './Themes/CyberWeekBanner';
import {
  shouldShowBoxingDayTheme,
  shouldShowChristmasTheme,
  shouldShowCyberWeek,
} from '@/lib/holidays';
import ChristmasBanner from './Themes/ChristmasBanner';
import BoxingDayTheme from './Themes/BoxingDayTheme';
import settings from '@/settings';

const HotDeals = ({ closeMenu }: HotDealsProps) => {
  if (settings.store === 'reebelo-fr') return null;

  if (shouldShowBoxingDayTheme) {
    return <BoxingDayTheme closeMenu={closeMenu} />;
  }

  if (shouldShowChristmasTheme) {
    return <ChristmasBanner closeMenu={closeMenu} />;
  }

  if (shouldShowCyberWeek) {
    return <CyberWeekBanner closeMenu={closeMenu} />;
  }

  return <DefaultBanner closeMenu={closeMenu} />;
};

export default HotDeals;
